<template>
  <div>
    <vue-dropzone
      ref="myVueDropzone"
      id="dropzone"
      :options="dropzoneOptions"
      @vdropzone-file-added="onFileAdded"
    ></vue-dropzone>
  </div>
</template>
<script>
import { createFile } from "@/graphql/Mutation";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
  name: "UploadTest",
  components: {
    vueDropzone: vue2Dropzone
  },
  data: function() {
    return {
      dropzoneOptions: {
        url:
          "https://onseminar-dev-public.s3.ap-northeast-2.amazonaws.com/channel/kita/profile/test.mp4",
        thumbnailWidth: 150,
        maxFilesize: 2000,
        chunking: true,
        chunkSize: 1024, // Bytes
        method: "put",
        autoProcessQueue: false
      }
    };
  },
  methods: {
    async onFileAdded(file) {
      console.log(file);
      try {
        const { data } = await this.$apollo.mutate({
          mutation: createFile,
          variables: {
            name: file.name,
            fileType: file.type,
            channel_id: this.$store.state.channelId,
            mode: "profile",
            timeout: 180000
          },
          fetchPolicy: "no-cache"
        });
        console.log(data.createFile.url);
        // this.$refs.myVueDropzone.setOption(
        //   "url",
        //   "https://onseminar-dev-public.s3.ap-northeast-2.amazonaws.com/channel/kita/profile/blue-1634110.png"
        // );
        // this.$refs.myVueDropzone.setAWSSigningURL(data.createFile.url);
        this.$refs.myVueDropzone.processQueue();
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>
